<template>
  <div class="invite-info-box">
    <div>
      <h4>开课信息</h4>
      <div>
        <h5>注册邀请码</h5>
        <div>
          <el-input :value="userInfo.inviteCode" placeholder="未申请开课" disabled />
        </div>
      </div>

      <div>
        <h5>可邀请用户数</h5>
        <div>
          <el-input :value="userInfo.inviteUserCountMax || 0" disabled>
            <el-button slot="append" type="primary" @click.native="inviteDialogVisible = true">开课申请</el-button>
          </el-input>
        </div>
      </div>
    </div>

    <apply-invite :visible.sync="inviteDialogVisible" />
  </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import applyInvite from './apply-invite'

    export default {
        components: {
            applyInvite
        },
        data() {
            return {
                formData: {},
                inviteDialogVisible: false
            }
        },
        computed: {
            ...mapGetters(['userInfo'])
        }
    }
</script>

<style lang="scss" scoped>
  .invite-info-box {
    h4 {
      line-height: 2em;
    }
    h5 {
      line-height: 2em;
      margin-top: 1em;
      &+div{
        margin-top: 0.6em;
      }
    }
    .el-input {
      width: 50%;
      min-width: 200px;
      max-width: 280px;
    }
  }
</style>
